import React from 'react'
import { useSelector } from 'react-redux'

import ModalLayout from '@/app/component/layout/modal'

import { selectPersonalizationList } from '../../logs/store/selectors'
import CopySegmentContent from './copy-segment-content'
import CreateSegmentForm from './form/create-segment-form'

type Props = {
  copyFrom?: number
  open: boolean
  onClose: () => void
}

const CreateSegmentDialog: React.FC<Props> = ({ copyFrom, open, onClose }) => {
  const pzList = useSelector(selectPersonalizationList)

  return (
    <ModalLayout title="Add segment" isOpen={open} onClose={onClose}>
      {open &&
        (copyFrom === undefined ? (
          <CreateSegmentForm personalizationList={pzList} onExit={onClose} />
        ) : (
          <CopySegmentContent key={copyFrom} personalizationList={pzList} segmentId={copyFrom} onExit={onClose} />
        ))}
    </ModalLayout>
  )
}

export default CreateSegmentDialog
